const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ?]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const FINANCIAL_FIELDS = [
  {
    id: "invoice_address",
    label: "Invoice Address",
    placeHolder: "Enter Invoice Address",
    type: "viewField",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "payment_terms",
    label: "Payment Terms",
    placeHolder: "Enter Payment Terms",
    type: "viewField",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "deposit_payment_percent",
    label: "Deposit Payment %",
    placeHolder: "Enter Deposit Payment %",
    type: "viewField",
    md: 3,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.PERCENTAGE,
  },
  {
    id: "invoice_due_days",
    label: "Invoice Due Days",
    placeHolder: "Enter Invoice Due Days",
    type: "viewField",
    md: 3,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "is_deposit_required",
    label: "Is Deposit Required ?",
    placeHolder: "Is Deposit Required",
    type: "viewField",
    inputProps: {
      marginBottom: "10px",
    },
    md: 3,
  },
  {
    id: "vat_percent",
    label: "VAT Percent",
    placeHolder: "Enter VAT Percent",
    type: "viewField",
    md: 3,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.PERCENTAGE,
  },
  {
    id: "vat_reg_no",
    label: "VAT Registration Number",
    placeHolder: "Enter VAT Registration Number",
    type: "viewField",
    md: 3,
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "is_fca_registered",
    label: "Is FCA Registered ?",
    placeHolder: "Is FCA Registered",
    type: "viewField",
    md: 3,
  },
  {
    id: "is_vat_included",
    label: "Is VAT Included ?",
    placeHolder: "Is VAT Included",
    type: "viewField",
    md: 3,
  },
  {
    id: "accounting_package",
    label: "Accounting Software",
    placeHolder: "Accounting Software",
    type: "viewField",
    md: 3,
  },
  {
    id: "bank_sort_code",
    label: "Bank Sort Code",
    placeHolder: "Enter bank sort code",
    type: "viewField",
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 3,
  },
  {
    id: "bank_account_no",
    label: "Bank Account No.",
    placeHolder: "Enter bank account number",
    type: "viewField",
    inputProps: {
      maxLength: 12,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 3,
    
  },
  {
    id: "account_holder_name",
    label: "Bank Account Holder Name",
    placeHolder: "Enter bank account holder name",
    type: "viewField",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 3,
   
  },
  {
    id: "iban",
    label: "IBAN",
    placeHolder: "Enter iban number",
    type: "viewField",
    inputProps: {
      maxLength: 100,
    },
    md: 3,
    
  },
  {
    id: "swift_no",
    label: "SWIFT No.",
    placeHolder: "Enter swift number",
    type: "viewField",
    inputProps: {
      maxLength: 100,
    },
    md: 3,
    
  },
  {
    id: "bank_name",
    label: "Bank Name",
    placeHolder: "Enter bank name",
    type: "viewField",
    inputProps: {
      maxLength: 100,
    },
    md: 3,
  },
  {
    id: "extended_liability_percent",
    label: "Insurance/Liability %",
    placeHolder: "Enter extend liability",
    type: "viewField",
    patternAllowed: patternConstant?.PERCENTAGE,
    info: "This is the percentage of the total removal cost that is charged for insurance on international and some UK jobs.",
    md: 3,
  },
  {
    id: "extended_liability_tax",
    label: "Insurance/Liability premium Tax",
    tooltipText: "Insurance/Liability premium Tax",
    placeHolder: "Enter extend liability tax",
    type: "viewField",
    editReadOnly: true,
    patternAllowed: patternConstant?.PERCENTAGE,
    md: 3,
    info: "An amount the company charges on all removals.",
  },
  {
    id: "insurance_fixed_rate",
    label: "Insurance/Liability Fixed Rate",
    tooltipText: "Insurance/Liability Fixed Rate",
    placeHolder: "Enter insurance fixed rate",
    type: "viewField",
    editReadOnly: true,
    patternAllowed: patternConstant?.PERCENTAGE,
    md: 3,
    info: "This is a mandatory tax that must be charged when insurance is sold, not Liability Cover. ",
  },
  {
    id: "invoice_serial_number",
    label: "Invoice Serial Number",
    placeHolder: "Enter invoice serial number",
    type: "viewField",
    md: 3,
  },
   {
    id: "ipc_percent",
    label: "IPC Percent",
    placeHolder: "Enter IPC Percent",
    type: "viewField",
    md: 3,
  },
   
  
];

export const ACCOUNTING_SOFTWARE_OPTIONS = [
  { label: "None", value: "None" },
  { label: "QuickBooks", value: "QuickBooks" },
  { label: "Xero", value: "Xero" },
  // { label: "Sage", value: "Sage" },
  // { label: "FreshBooks", value: "FreshBooks" },
  // { label: "Wave", value: "Wave" },
];

export const FIRST_FINANCIAL_FIELDS = [
  {
    id: "invoice_address",
    label: "Invoice Address",
    placeHolder: "Enter invoice address",
    type: "text",
    isRequired: true,
    md: 9,
  },
  {
    id: "is_same_with_company_address",
    label: "\u00A0",
    checkLabel: "Same as the company's",
    placeHolder: "select",
    type: "checkbox",
    md: 3,
  },
  {
    id: "payment_terms",
    label: "Payment Terms",
    placeHolder: "Enter payment terms",
    type: "text",
    inputProps: {
      maxLength: 100,
    },
    isRequired: true,
    md: 12,
  },
  {
    id: "bank_sort_code",
    label: "Bank Sort Code",
    placeHolder: "Enter bank sort code",
    type: "text",
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 3,
  },
  {
    id: "bank_account_no",
    label: "Bank Account No.",
    placeHolder: "Enter bank account number",
    type: "text",
    inputProps: {
      maxLength: 12,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 3,
  },
  {
    id: "account_holder_name",
    label: "Bank Account Holder Name",
    placeHolder: "Enter bank account holder name",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 3,
  },
  {
    id: "iban",
    label: "IBAN",
    placeHolder: "Enter iban number",
    type: "text",
    inputProps: {
      maxLength: 100,
    },
    md: 3,
  },
  {
    id: "swift_no",
    label: "SWIFT No.",
    placeHolder: "Enter swift number",
    type: "text",
    inputProps: {
      maxLength: 100,
    },
    md: 3,
  },
  {
    id: "bank_name",
    label: "Bank Name",
    placeHolder: "Enter bank name",
    type: "text",
    inputProps: {
      maxLength: 100,
    },
    md: 3,
  },
  {
    id: "invoice_due_days",
    label: "Invoice Due Days",
    placeHolder: "Enter invoice due days",
    type: "text",
    patternAllowed: patternConstant?.NUMERIC,
    inputProps: {
      maxLength: 3,
    },
    md: 3,
    // info:'Number of days after which the invoice is due.'
  },
  {
    id: "deposit_payment_percent",
    label: "Deposit Payment %",
    placeHolder: "Enter deposit payment percent",
    type: "text",
    patternAllowed: patternConstant?.PERCENTAGE,
    md: 3,
  },
  {
    id: "extended_liability_percent",
    label: "Insurance/Liability %",
    placeHolder: "Enter extend liability",
    type: "text",
    patternAllowed: patternConstant?.PERCENTAGE,
    info: "This is the percentage of the total removal cost that is charged for insurance on international and some UK jobs.",
    md: 3,
  },
  {
    id: "extended_liability_tax",
    label: "Insurance/Liability premium Tax",
    tooltipText: "Insurance/Liability premium Tax",
    placeHolder: "Enter extend liability tax",
    type: "text",
    editReadOnly: true,
    patternAllowed: patternConstant?.PERCENTAGE,
    md: 3,
    info: "An amount the company charges on all removals.",
  },
  {
    id: "insurance_fixed_rate",
    label: "Insurance/Liability Fixed Rate",
    tooltipText: "Insurance/Liability Fixed Rate",
    placeHolder: "Enter insurance fixed rate",
    type: "text",
    editReadOnly: true,
    patternAllowed: patternConstant?.PERCENTAGE,
    md: 3,
    info: "This is a mandatory tax that must be charged when insurance is sold, not Liability Cover. ",
  },

  {
    id: "accounting_package",
    label: "Accounting Software",
    placeHolder: "",
    type: "select",
    options: ACCOUNTING_SOFTWARE_OPTIONS,
    md: 3,
  },
  {
    id: "is_deposit_required",
    label: "Is Deposit Required ?",
    checkLabel: "",
    placeHolder: "Is Deposit Required",
    type: "checkbox",
    md: 2,
  },
  {
    id: "is_fca_registered",
    label: "Is FCA Registered ?",
    checkLabel: "",
    placeHolder: "Is FCA Registered",
    type: "checkbox",
    md: 2,
  },
   {
    id: "is_vat_included",
    label: "VAT Included",
    checkLabel: "",
    placeHolder: "VAT Included",
    type: "checkbox",
    md: 2,
  },
   {
    id: "invoice_serial_number",
    label: "Invoice Serial Number ⓘ",
    placeHolder: "Enter invoice serial number",
    type: "text",
    patternAllowed: patternConstant?.NUMERIC,
    inputProps: {
      maxLength: 3,
    },
    md: 3,
    tooltipText:'If any invoice is generated, this option will be disabled and the start number cannot be changed.'
  },
  {
    id: "ipc_percent",
    label: "IPC Percent",
    type: "text",
    md: 3,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    // editReadOnly: true,
    patternAllowed: patternConstant?.PERCENTAGE,
  },
  {
    id: "vatRegNoOptions",
    label: "Do you have a VAT Registration No.?",
    type: "radio", // Define as radio button
    options: [], // Define the options
    md: 4,
    isRequired: true,
  },
  {
    id: "vat_percent",
    label: "VAT Percent",
    placeHolder: "Enter VAT Percent",
    type: "text",
    md: 3,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    // editReadOnly: true,
    patternAllowed: patternConstant?.PERCENTAGE,
  },
  {
    id: "vat_reg_no",
    label: "VAT Registration Number",
    placeHolder: "Enter VAT Registration Number",
    type: "text",
    md: 3,
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    // editReadOnly: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  
];

export const CANCELLATION_FEES_FIELDS = [
  {
    id: "days",
    label: "",
    placeHolder: "Enter days",
    type: "text",
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "percent",
    label: "",
    placeHolder: "Enter percent",
    type: "text",
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.PERCENTAGE,
  },
];

export const INVOICE_TYPE_FIELDS = [
  {
    id: "title",
    label: "",
    placeHolder: "Enter title",
    type: "text",
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "description",
    label: "",
    placeHolder: "Enter description",
    type: "text",
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "is_delete",
    label: "",
    placeHolder: "is_delete",
    type: "checkbox",
    md: 4,
  },
];
export const PAYMENT_METHOD_FIELDS = [
  {
    id: "title",
    label: "",
    placeHolder: "Enter title",
    type: "text",
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "description",
    label: "",
    placeHolder: "Enter description",
    type: "text",
    md: 4,
    // isRequired: true,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "is_delete",
    label: "",
    placeHolder: "is_delete",
    type: "checkbox",
    md: 4,
  },
];
